import React from 'react';
import WaterLevelIndicator from './WaterLevelIndicator';
import MineralsLevelIndicator from './MineralsLevelIndicator';

const SummaryPanel = ({ spaces, showWaterLevel, translations, error }) => {
  if (!showWaterLevel) return null;

  return (
    <div className="summary-panel">
      <h3>Water & Minerals Levels</h3>
      {spaces.map(space => (
        <div key={space.id} className="space-panel">
          <h3 className="space-name">{space.name}</h3>
          <div className="hubs-container">
            {space.hubs.map(hub => {
              const hasMeasure = hub.lastMeasure && hub.lastMeasure !== -1;
              const hasMinerals =
                hasMeasure &&
                hub.lastMeasure.minerals !== undefined &&
                hub.lastMeasure.minerals !== -1;

              return (
                <div key={hub.id} className="hub-panel">
                  <div className="hub-details">
                    <span className="hub-name">{hub.name}</span>

                    {/* Water Level */}
                    <span className="water-level">
                      {hasMeasure && hub.lastMeasure.water_level !== undefined ? (
                        <>
                          <WaterLevelIndicator waterLevel={hub.lastMeasure.water_level} />
                          <span>{`${hub.lastMeasure.water_level}%`}</span>
                        </>
                      ) : (
                        <>
                          <WaterLevelIndicator
                            waterLevel={hub.irrigation_system_enabled ? 0 : hub.lastMeasure}
                          />
                          <span>
                            {hub.irrigation_system_enabled
                              ? translations.no_measures
                              : translations.no_irrigation_system}
                          </span>
                        </>
                      )}
                    </span>

                    {/* Minerals Level (categorized) */}
                    <span className="minerals-level" style={{ marginLeft: 12 }}>
                      {hasMinerals ? (
                        <>
                          {/* Pass raw value; no percentage */}
                          <MineralsLevelIndicator
                            value={hub.lastMeasure.minerals}
                            showValue={false}
                            // unit="ppm" // <- uncomment if you want to show a unit
                          />
                        </>
                      ) : (
                        <>
                          <MineralsLevelIndicator
                            value={-1} // signals "No data"
                            showValue={false}
                          />
                          <span style={{ marginLeft: 8 }}>
                            {hub.irrigation_system_enabled
                              ? translations.no_measures
                              : translations.no_irrigation_system}
                          </span>
                        </>
                      )}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}
      {error && <p className="error">{error}</p>}
    </div>
  );
};

export default SummaryPanel;
